import {AbTabsController} from "@/scripts/components/ab-tabs/abTabs.controller";
import "./abTabs.style.scss";
import {NAMES} from "@/scripts/components/ab-tabs/constants/abTabs.constants";

export function defineAbTabsElement() {

  const TAG_NAME = NAMES.TAG_NAME;
  if (customElements.get(TAG_NAME)) return;

  class AbTabsElement extends HTMLElement {
    #ctrl?: AbTabsController;
    connectedCallback() {
      this.#ctrl = new AbTabsController(this);
    }
    disconnectedCallback() {
      this.#ctrl?.destroy();
    }
  }
  customElements.define(TAG_NAME, AbTabsElement);
}